export default __webpack_public_path__ + "static/media/img-slider-asaph-4.68d0edf3.png";